import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getconfigdata } from "../../ReduxStore/Slice/ConfigSettings/ConfigSettings";
import History from "./History";
import ReadOnlyConfigSetting from "./ReadOnlyConfigSetting";
import { useNavigate } from "react-router-dom";

const ViewConfigSetting = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));

    const [currantTab, setCurrantTab] = useState(1);
    const [configData, setConfigData] = useState(null);
    const [loading, setLoading] = useState(true);

    const tabs = [
        { value: 1, name: "Information" },
        { value: 2, name: "History" },
    ];

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const req = { agent_id: agent_id };
        await dispatch(getconfigdata(req))
            .unwrap()
            .then((response) => {
                if (response.status) {
                    setConfigData(response.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching config data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="view-config-setting">
            <div className="row mb-3">
                <div className="col">
                    <h4 className="page-title">
                        <button className="btn p-0 fs-5" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back text-pink"></i>
                        </button> Configuration Settings
                        <span>
                            <i className="ri-arrow-right-s-line"></i> {currantTab === 1 ? "Information" : "History"}
                        </span>
                    </h4>
                </div>
            </div>

            <ul className="nav nav-tabs nav-tabs-bordered">
                {tabs.map((tab) => (
                    <li className="nav-item" role="presentation" key={tab.value}>
                        <button
                            className={`nav-link ${currantTab === tab.value ? "active" : ""}`}
                            type="button"
                            onClick={() => setCurrantTab(tab.value)}
                        >
                            {tab.name}
                        </button>
                    </li>
                ))}
            </ul>
            <div className="tab-content pt-2">
                {!loading && (
                    <>
                        <div className={`tab-pane fade ${currantTab === 1 ? 'show active' : ""}`}>
                            <ReadOnlyConfigSetting configdata={configData} />
                        </div>
                        <div className={`tab-pane fade ${currantTab === 2 ? 'show active' : ""}`}>
                            <History historyData={configData?.ConfigSettingHistories || []} />
                        </div>
                    </>
                )}
                {loading && <div>Loading...</div>}
            </div>
        </div>
    );
};

export default ViewConfigSetting;
